export default () => {
  const apikey = process.env.VUE_APP_TRANSFER_TRACKING_API_KEY;
  return apikey ? { apikey } : {};
};
